export default function () {
    return {
        localDateTimePattern: "DD-MM-YYYY HH:mm:ss"
    }
}
